import React, { useState } from "react";
import { NavLink } from "react-router-dom";
// Long-standing icon names only: SpaceDashboard/ManageAccounts were added in
// later @mui/icons-material releases and break the build on installs that
// resolve to an earlier 5.x.
import {
  DashboardOutlined,
  GroupOutlined,
  SupervisorAccountOutlined,
} from "@mui/icons-material";
import AdminHeader from "./AdminHeader";

const NAV = [
  { to: "/admin", exact: true, icon: <DashboardOutlined />, label: "Dashboard" },
  { to: "/admin/users", icon: <GroupOutlined />, label: "Users" },
  { to: "/admin/admins", icon: <SupervisorAccountOutlined />, label: "Admins" },
];

const AdminLayout = ({ children }) => {
  const [open, setOpen] = useState(
    () => localStorage.getItem("adminSidebarOpen") === "true"
  );

  const toggle = () =>
    setOpen((prev) => {
      const next = !prev;
      localStorage.setItem("adminSidebarOpen", String(next));
      return next;
    });

  return (
    <div className="admin-root">
      <AdminHeader onMenuClick={toggle} />
      <div className="admin-body">
        {open && (
          <aside className="admin-sidebar-drawer">
            <nav className="admin-sidebar-nav">
              {NAV.map(({ to, exact, icon, label }) => (
                <NavLink key={to} exact={exact} to={to} activeClassName="active">
                  <span className="nav-icon">{icon}</span>
                  <span className="nav-label">{label}</span>
                </NavLink>
              ))}
            </nav>
          </aside>
        )}
        <main className="admin-panel">
          <div className="container">
            <section className="admin-main">{children}</section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
